import { Alert, AlertProps, TextProps, Text } from "@mantine/core"

export function WarningAlert({
  error,
  ...props
}: AlertProps & { error: Error | string | null | undefined }) {
  if (error === undefined || error === null) return null
  const errorMessage = typeof error === "string" ? error : error.message
  return (
    <Alert color="orange" variant="light" {...props}>
      {errorMessage}
    </Alert>
  )
}

export function ErrorAlert({
  error,
  ...props
}: AlertProps & { error: Error | string | null | undefined }) {
  if (error === undefined || error === null) return null
  const errorMessage = typeof error === "string" ? error : error.message
  return (
    <Alert color="red" variant="filled" {...props}>
      {errorMessage}
    </Alert>
  )
}

export function ErrorText({
  error,
  ...props
}: TextProps & { error: Error | string | null | undefined }) {
  if (error === undefined || error === null) return null
  const errorMessage = typeof error === "string" ? error : error.message
  return (
    <Text c="red" {...props}>
      {errorMessage}
    </Text>
  )
}
